module.exports = __webpack_public_path__ + "img/product_desk_10.c5fe8ae4.jpg";